import { Button, Upload, UploadFile } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import ModalUpdateImages from './ModalUpdateImages/ModalUpdateImages';
import ModalViewImages from './ModalUpdateImages/ModalViewImages';
import OrderManagerApi from 'apis/api/OrderManager';
import {
  getOrderImagesRaw,
  ORDER_IMAGE_KIND_LABEL,
  toUploadFiles,
  TOrderImageKind
} from './ModalUpdateImages/orderImageUtils';

const getBase64 = file =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });

const MAX_THUMBS = 3;

interface IUploadImages {
  status?: any;
  data?: any;
  typeKeyOrder?: any;
  rowSelected?: any;
  /** 'tech' = images (mặc định, luồng cũ) | 'creator' = creatorImages của người tạo đơn */
  kind?: TOrderImageKind;
  /** chỉ xem: ẩn nút thêm ảnh, modal không cho sửa */
  readOnly?: boolean;
}

export default function UploadImages(props: IUploadImages) {
  const kind = props.kind ?? 'tech';
  const [previewImage, setPreviewImage] = useState('');
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [openModalView, setOpenModalView] = useState<boolean>(false);

  const [listHinh, setListHinh] = useState<UploadFile[]>([]);
  const [listHinhNew, setListHinhNew] = useState<UploadFile[]>([]);
  const [images1, setImages1] = useState<any>();
  const handlePreview = async file => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setImages1(file);
    setOpenModalView(true);
  };
  const handleUpload = ({ fileList }) => {
    setListHinhNew([...fileList]);
  };

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  // memo để effect bên dưới không chạy lại mỗi render (getOrderImagesRaw trả [] mới khi đơn chưa có ảnh)
  const rawImages = useMemo(() => getOrderImagesRaw(props.rowSelected, kind), [props.rowSelected, kind]);

  const callBackRefresh = () => {
    // gọi api lại
    try {
      OrderManagerApi.GetDetailOfOrder(props?.data?.maDonHang, props?.typeKeyOrder).then(res => {
        if (!res.data.error) {
          setListHinh(toUploadFiles(getOrderImagesRaw(res?.data?.data, kind)));
        }
      });
    } catch (error) {
      console.log('error', error);
    }
  };

  useEffect(() => {
    setListHinh(toUploadFiles(rawImages));
  }, [rawImages]);

  const total = listHinh?.length || 0;
  if (props.readOnly && total === 0) return null;

  return (
    <>
      {openModalView && (
        <ModalViewImages
          isOpen={openModalView}
          base64={previewImage}
          images1={images1}
          listHinh={listHinh || []}
          listHinhNew={listHinhNew}
          data={props}
          status={props?.status}
          callBackClose={() => setOpenModalView(false)}
          callBackRefresh={callBackRefresh}
        />
      )}

      {openModal && (
        <ModalUpdateImages
          isOpen={openModal}
          base64={previewImage}
          listHinh={listHinh || []}
          data={props}
          status={props?.status}
          kind={kind}
          readOnly={props.readOnly}
          callBackClose={() => setOpenModal(false)}
          callBackRefresh={callBackRefresh}
        />
      )}
      <div className="flex flex-col gap-1 min-w-0">
        <div className="text-[12px] font-semibold text-gray-600">
          {ORDER_IMAGE_KIND_LABEL[kind]} {total > 0 ? `(${total})` : ''}
        </div>
        <div className="flex flex-wrap items-center gap-2 min-w-0">
          {total > 0 && (
            <Upload
              className="order-images-thumbs"
              onPreview={handlePreview}
              onChange={handleUpload}
              showUploadList={{ showRemoveIcon: false }}
              listType="picture-card"
              fileList={listHinh.slice(0, MAX_THUMBS)}
            />
          )}

          {(!props.readOnly || total > MAX_THUMBS) && (
            <Button
              type="primary"
              onClick={e => {
                e.preventDefault();
                e.stopPropagation();
                handleOpenModal();
              }}
            >
              {total > MAX_THUMBS ? `+${total - MAX_THUMBS} Ảnh` : 'Thêm ảnh'}
            </Button>
          )}
        </div>
      </div>
    </>
  );
}
